// extracted by mini-css-extract-plugin
module.exports = {"colorContent05":"#637083","colorBrandBackgroundPrimary":"#f0f6ff","colorDangerPrimary":"#f64c4c"};